export default __webpack_public_path__ + "static/media/footerImg2.aa868834.png";